<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Nasce a Friboi</h2>
          <p>
            Após o término da construção de Brasília (DF), Zé Mineiro expande
            seu negócio com a compra da primeira unidade de processamento de
            bovinos, na cidade de Formosa (GO), para abastecer a população da
            capital federal. Por sugestão de um amigo, surge a marca
            <strong>Friboi</strong>, nome que vem da junção das palavras
            frigorífico e boi.
          </p>
          <img
            src="../assets/img/1970/1970-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/1970/1970-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1973/04/27/g/19730427-30085-nac-0025-999-25-not-wsgswqq.jpg'
              )
            "
            class="span2"
          />
          <img
            src="../assets/img/1970/1970-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1972/03/01/g/19720301-29727-nac-0010-999-10-not-eqapgpx.jpg'
              )
            "
          />
          <img
            src="../assets/img/1970/1970-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1974/08/11/g/19740811-30483-nac-0045-999-45-not-gshewhq.jpg'
              )
            "
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require('@/assets/img/1970/1970-1-full.jpg'),
          title: '1970 - Nasce a Friboi ',
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 140px;
    display: grid;
    grid-template-columns: 485px 1fr;
    gap: 70px;
    @include media('<=desktop') {
      display: block;
    }
  }
  &__warpper {
    position: relative;
    @include media('<=desktop') {
      padding: 20px;
    }
    &__item {
      position: relative;

      &--image {
        display: grid;
        grid-template-columns: 1fr 1fr;
        position: relative;
        max-height: 700px;
        @include media('<=desktop') {
          max-height: initial;
          justify-content: center;
        }
        img {
          max-height: 374px;
        }
        .span2 {
          grid-column: span 2;
        }
        span {
          position: absolute;
          left: 0%;
          bottom: 20px;
          width: 65px;
          color: color(cGreen);
          strong {
            color: color(cGreen);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(primary);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
        @include media('<=desktop') {
          color: color(cWhite);
        }
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
        @include media('<=desktop') {
          color: color(cWhite);
        }
      }

      &--black {
        margin-left: 1.6rem;
        padding-top: 10px;
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 150.5%;
          margin-bottom: 20px;
        }
        blockquote {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 2.1875rem;
          font-style: normal;
          font-weight: 700;
          line-height: 106.5%;
          text-align: right;
          max-width: 14rem;
          margin: 0.6rem 0;
          margin-left: auto;
        }
      }
    }
    &::after {
      content: '';
      background: url(../assets/img/1970/1970-fundo.jpg);
      width: 43%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        width: 100%;
      }
    }
  }
}
</style>
